"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.search = void 0;
exports.search = {
    path: "M10.4707 9.87919H11.1291L15.2874 14.0459L14.0457 15.2875L9.87907 11.1292V10.4709L9.65407 10.2375C8.70407 11.0542 7.47074 11.5459 6.12907 11.5459C3.1374 11.5459 0.712402 9.12086 0.712402 6.12919C0.712402 3.13752 3.1374 0.712521 6.12907 0.712521C9.12074 0.712521 11.5457 3.13752 11.5457 6.12919C11.5457 7.47085 11.0541 8.70419 10.2374 9.65419L10.4707 9.87919ZM2.37907 6.12919C2.37907 8.20419 4.05407 9.87919 6.12907 9.87919C8.20407 9.87919 9.87907 8.20419 9.87907 6.12919C9.87907 4.05419 8.20407 2.37919 6.12907 2.37919C4.05407 2.37919 2.37907 4.05419 2.37907 6.12919Z",
    originalWidth: 16,
    originalHeight: 14,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
